import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object } from "yup";
import { OrderFormValues } from "src/models/Order.model";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import OrderForm from "../Layouts/OrderForm";
import {
  useGetOrderByIdQuery,
  useUpdateOrderByIdMutation,
} from "src/services/OrderService";

type Props = {
  onClose: () => void;
  selectedOrderId: string;
};

const EditOrderWrapper = ({ onClose, selectedOrderId }: Props) => {
  const [items, setItems] = useState<Partial<OrderFormValues>>({});

  const { isLoading, isFetching, data } = useGetOrderByIdQuery(selectedOrderId);
  const [updateOrderById] = useUpdateOrderByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching && data?.data) {
      setItems(data.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: OrderFormValues = {
    _id: items?._id || "",
    orderUnqId: items?.orderUnqId || "",
    userId: items?.userId || "",
    userName: items?.userName || "",
    mobile: items?.mobile || "",
    productId: items?.productId || null,
    productName: items?.productName || "",
    productVarientCode: items?.productVarientCode || "",
    productMrp: items?.productMrp || 0,
    productDiscount: items?.productDiscount || 0,
    productQuantity: items?.productQuantity || 0,
    allOrderQuantity: items?.allOrderQuantity || 0,
    allOrderMrp: items?.allOrderMrp || 0,
    allOrderDisocuntAmount: items?.allOrderDisocuntAmount || 0,
    totalCourierCharges: items?.totalCourierCharges || 0,
    totalDiscountAmount: items?.totalDiscountAmount|| 0,
    orderAmt: items?.orderAmt || 0,
    productDiscountAmount: items?.productDiscountAmount || 0,
    productEffectivePrice: items?.productEffectivePrice || 0,
    discountType: items?.discountType || "",
    couponCode: items?.couponCode || "",
    couponDiscount: items?.couponDiscount || 0,
    referralCode: items?.referralCode || "",
    referralToDiscountAmount: items?.referralToDiscountAmount || 0,
    referralByDiscountAmount: items?.referralByDiscountAmount || 0,
    walletDiscountAmount: items?.walletDiscountAmount || 0,
    orderStatus: items?.orderStatus || "",
    paymentStatus: items?.paymentStatus || "",
    paymentGateway: items?.paymentGateway || "",
    transactionId: items?.transactionId || "",
    razorpayOrderId: items?.razorpayOrderId || "",
    productImage: items?.productImage || [],
    modeId: items?.modeId || "",
    modeName: items?.modeName || "",
    faculty: items?.faculty || [{ facultyName: "" }],
    deliveryDetails: {
      address: items?.deliveryDetails?.address || "",
      city: items?.deliveryDetails?.city || "",
      state: items?.deliveryDetails?.state || "",
      pincode: items?.deliveryDetails?.pincode || "",
      firstName: items?.deliveryDetails?.firstName || "",
      lastName: items?.deliveryDetails?.lastName || "",
      email: items?.deliveryDetails?.email || "",
      landmark: items?.deliveryDetails?.landmark || "",
      altMobile: items?.deliveryDetails?.altMobile || "",
      country: items?.deliveryDetails?.country || "",
      mobile: items?.deliveryDetails?.mobile || "", // ✅ added
    },

    additionalNotes: items?.additionalNotes || "",
    transactions: items?.transactions || [], // ✅ added
    isDeleted: items?.isDeleted ?? false, // ✅ added
    isActive: items?.isActive ?? true, // ✅ added
    createdAt: items?.createdAt || "",
    updatedAt: items?.updatedAt || "", // ✅ added
  };

  // Validation Schema
  const validationSchema = object().shape({});

  // Handle Submit
  const handleSubmit = (
    values: OrderFormValues,
    { setSubmitting, resetForm }: FormikHelpers<OrderFormValues>
  ) => {
    const payload = values; // send actual form values
    updateOrderById({ id: selectedOrderId, body: payload }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <OrderForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditOrderWrapper;
